
const UPDATE_NEW_MESSAGE_BODY = 'UPDATE_NEW_MESSAGE_BODY';
const SEND_MESSAGE = 'SEND_MESSAGE';

let initialState = {
    dialogs: [
        {id: 1, name: 'Dimych'},
        {id: 2, name: 'Andrew'},
        {id: 3, name: 'Sveta'},
        {id: 4, name: 'Sasha'},
        {id: 5, name: 'Viktor'},
        {id: 6, name: 'Valera'}
    ],
    messages: [
        {id: 1, message: 'Hdsfgvbdfbvdfi'},
        {id: 2, message: 'How is your it-kamasutra?'},
        {id: 3, message: 'Yfdghdfgdsfgvo'},
        {id: 4, message: 'Yofdb dfgbdrb'},
        {id: 5, message: 'Y ergdrbo'}
    ],
}

const dialogsReducer = (state = initialState, action) => {

   /* let stateCopy = {
        ...state,
        /!*messages: {...state.messages}*!/
    }*/

    switch (action.type) {
        case SEND_MESSAGE:
            let body = action.newMessageBody;
            return {
                ...state,
                messages: [...state.messages, {id: 6, message: body}]
            }
        default:
            return state;

    }

}

export const sendMessageCreator = (newMessageBody) => ({type: SEND_MESSAGE, newMessageBody})

export default dialogsReducer



